import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Compass } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = hash.get("session_id");
    if (!sessionId) {
      navigate("/admin/login", { replace: true, state: { googleError: "Sessione Google mancante" } });
      return;
    }
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then(() => refresh())
      .then(() => {
        window.history.replaceState({}, "", "/admin");
        navigate("/admin", { replace: true });
      })
      .catch((e) => {
        setError(formatApiError(e));
        navigate("/admin/login", { replace: true, state: { googleError: formatApiError(e) } });
      });
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-screen bg-obsidian flex items-center justify-center" data-testid="google-auth-callback">
      <div className="text-center">
        <Compass className="h-8 w-8 text-copper mx-auto animate-slowpulse" />
        <p className="font-mono text-xs tracking-[0.3em] text-copper mt-4">ACCESSO CON GOOGLE…</p>
        {error && <p className="text-red-400 text-sm mt-4 px-6">{error}</p>}
      </div>
    </div>
  );
}
